
const textStyle = {
  paddingTop: '25px',
};

const rowStyle = {

};

const imageRow = {
  width: '50px',
};

const imageStyle = {
  height: '50px',
  borderRadius: '3px',
};

const alert = {
  color: '#ff0',
  textShadow: '0.2em 0.2em 0.2em #868600',
};

const rowBackgroundAlert = {
  background: '#f6e8b3',
};

export default {
  textStyle,
  rowStyle,
  imageRow,
  imageStyle,
  alert,
  rowBackgroundAlert,
};



// WEBPACK FOOTER //
// ./src/scenes/Medication/components/MedicationList/components/MedicationRow/style.js